










import { mapState } from "vuex";
import { AutomaticLoginInterface } from "@/types";
import { UrlHelper } from "@/helpers/UrlHelper";
import Vue from "vue";

export default Vue.extend({
  name: "AutomaticLoginForm",
  data() {
    return {
      clientZoneToken: "",
      baseURL: "",
      TRANSLATION_KEY: "AutomaticLoginForm",
    } as AutomaticLoginInterface;
  },
  mounted() {
    this.setToken();
    this.getBaseURLClientZone();

    const tokenInterval = setInterval(() => {
      if (this.clientZoneToken !== 'null') {
        clearInterval(tokenInterval)
        // @ts-ignore
        this.$refs.redirectBtn.click();
      }
    }, 200)
    setTimeout(() => {
      // @ts-ignore
        this.$refs.redirectBtn.click();
    }, 2000);
  },
  methods: {
    setToken(): void {
      this.clientZoneToken = this.clientZoneTokenResponse || this.getToken();
    },

    getToken(): string {
      return decodeURIComponent(UrlHelper.getQueryParam("UserToken")!);
    },

    getBaseURLClientZone(): void {
      this.baseURL = UrlHelper.getClientZoneUrl().concat("/api/autoLogin");
    },
  },
  computed: {
    ...mapState({
      clientZoneTokenResponse: (state: any): string => state.formData.clientZoneToken,
      urlParams: (state: any): string => state.AdjustUrlParams,
    }),
  },
});
